<template>
  <div
    :class="[isLoading ? 'd-flex' : 'd-none']"
    class="overlay justify-content-center align-items-center"
  >
    <div class="spinner-border" style="width: 3rem; height: 3rem" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'LoadingComponent',
    props: {
      isLoading: {
        type: Boolean,
      },
    },
  })
</script>

<style scoped>
  .overlay {
    top: 0;
    position: fixed;
    z-index: 9999999999;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0.5;
  }
</style>
